'use strict';
import Backbone from 'backbone';
import $ from 'jquery';
import config from '../../js/config';
import mediator from '../../js/mediator';
import * as featureFlags from '../../utilities/featureFlags';
import analytics from '../Analytics/Analytics';
import ActivateResendModalView from '../Login/ActivateResendModal';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
const GetStartedView = Backbone.View.extend ({
  events: {
    'click .resend-email-link': 'resendEmailLink',
    'click .login-link': 'redirectToLogin',
    'click #GetStartedForm-submitButton': 'continueClick',
    'keyup .RegistrationForm-email': 'removeEmailErrorMessages'
  },
  initialize: function() {
    this.$email = $('#email');
    this.isApacRegion = document.getElementById('region').value;
    this.$userAlreadyExists = $('.user-already-exists');
    this.$somethingWentWrong = $('.message-fail');
    this.$continueButton = $('#GetStartedForm-submitButton');
    this.$getStartedForm = this.$el.find('.GetStartedForm');
    this.token = '';
    this.mtCaptchaToken = '';
    this.resendEmailFlag = false;
    this.pageLoad = true;
    mediator.on(config.events.registration.reCaptchaSucess, this.reCaptchaSuccessCallback, this);
    mediator.on(config.events.registration.mtCaptchaSucess, this.mtCaptchaSuccessCallback, this);
    window.onReCaptchaSubmit = this.reCaptchaCallback;
    window.onMTCaptchaSubmit = this.mtCaptchaCallback;
    this.$email.focus();
    $('.mtcaptcha').css('display', 'none');
  },
  reCaptchaCallback(token) {
    mediator.trigger(config.events.registration.reCaptchaSucess, token);
  },
  mtCaptchaCallback(state) {
    mediator.trigger(config.events.registration.mtCaptchaSucess, state.verifiedToken);
  },
  mtCaptchaSuccessCallback(token) {
    this.mtCaptchaToken = token;
    if (!this.pageLoad) {
      if (this.resendEmailFlag) {
        this.resendEmail();
      } else {
        this.verifyActivateEmail();
      }
    }
    console.log('mtcaptcha callback called');
  },
  reCaptchaSuccessCallback(token) {
    this.token = token;
    if (this.resendEmailFlag) {
      this.resendEmail();
    } else {
      if (this.$continueButton.is(':hidden')) {
        this.$continueButton.show();
      } else {
        this.verifyActivateEmail();
      }
    }
  },
  redirectToLogin: function(e) {
    e.preventDefault();
    window.location.href = config.urls.loginPage;
  },
  continueClick: function(e) {
    e.preventDefault();
    if (this.$el.find('.GetStartedForm').valid()) {
      if (this.isApacRegion === 'true') {
        this.pageLoad = false;
        $('.mtcaptcha').css('display', 'block');
        if (featureFlags.EnableMTCaptcha.isEnabled() && (mtcaptcha && mtcaptcha.getVerifiedToken())) {
          if (!this.mtCaptchaToken) {
            this.mtCaptchaToken = mtcaptcha.getVerifiedToken();
          }
          this.verifyActivateEmail();
        } else if (!featureFlags.EnableMTCaptcha.isEnabled()) {
          this.verifyActivateEmail();
        }
      } else {
        featureFlags.EnableReCaptcha.isEnabled() && grecaptcha && this.token === '' ? grecaptcha.execute() : this.verifyActivateEmail();
      }
    } else {
      if (!this.$email.val()) {
        this.$email.focus();
      }
      if (EnableAdobeAnalytics.isEnabled()) {
        analytics.pushFormErrorData('Get Started', this.getErrorMessages());
      }
    }
    $('span.is-invalid').addClass('error-message-icon');
  },

  verifyActivateEmail: function() {
    this.$continueButton.addClass(config.classes.isWhite).addClass(config.classes.loadingClass);
    this.registerInitUser().then((data) => {
      if (data.data.success) {
        $('.get-started').hide();
        $('.verify-and-activate-account').css('display', 'block');
        this.token = '';
        this.mtCaptchaToken = '';
        this.pageLoad = true;
        if (EnableAdobeAnalytics.isEnabled()) {
          analytics.pushFormInteractionData('form_submit', 'Get Started');
        }
      } else {
        this.handleFailedRegistration(data);
        if (EnableAdobeAnalytics.isEnabled()) {
          analytics.pushFormErrorData('Get Started', this.getErrorMessages());
        }
      }
    });
    if (this.isApacRegion === 'false') {
      if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
        grecaptcha.reset();
      }
    } else {
      $('.mtcaptcha').css('display', 'none');
      if (featureFlags.EnableMTCaptcha.isEnabled() && mtcaptcha) {
        mtcaptcha.resetUI();
        this.pageLoad = true;
      }
    }
  },
  resendEmailLink: function(e) {
    e.preventDefault();
    this.resendEmailFlag = true;
    console.log('featureFlags.EnableMTCaptcha.isEnabled' + featureFlags.EnableMTCaptcha.isEnabled());
    if (this.isApacRegion === 'true') {
      this.pageLoad = false;
      $('.mtcaptcha').css('display', 'block');
      if (featureFlags.EnableMTCaptcha.isEnabled() && (mtcaptcha && mtcaptcha.getVerifiedToken())) {
        if (!this.mtCaptchaToken) {
          this.mtCaptchaToken = mtcaptcha.getVerifiedToken();
        }
        this.resendEmail();
      } else if (!featureFlags.EnableMTCaptcha.isEnabled()) {
        this.resendEmail();
      }
    } else {
      featureFlags.EnableReCaptcha.isEnabled() && grecaptcha && this.token === '' ? grecaptcha.execute() :  this.resendEmail();
    }
  },
  getErrorMessages: function() {
    let error_messages = [];
    let $formError = this.$getStartedForm.find('.is-invalid').filter('span');
    let emaillabel = this.$getStartedForm.find('label').text();
    if ($formError.css('display') === 'block') {
      error_messages.push({
        error_message: $formError.text() || undefined,
        form_field_type: emaillabel || undefined
      });
    }
    if (this.$userAlreadyExists.css('display') === 'block') {
      error_messages.push({
        error_message: this.$userAlreadyExists.text().trim() || undefined,
        form_field_type: emaillabel || undefined
      });
    }
    if (this.$somethingWentWrong.css('display') === 'block') {
      error_messages.push({
        error_message: this.$somethingWentWrong.text().trim() || undefined,
        form_field_type: undefined
      });
    }
    return error_messages;
  },

  resendEmail: function() {
    this.registerInitUser().then((data) => {
      if (data.data.success) {
        this.token = '';
        this.mtCaptchaToken = '';
        if (this.isApacRegion === 'false') {
          if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
            grecaptcha.reset();
          }
        } else {
          $('.mtcaptcha').css('display', 'none');
          this.pageLoad = true;
        }
        new ActivateResendModalView();
      } else {
        $('.resend-email-message-fail').addClass(config.classes.isActive);
      }
    });
  },
  registerInitUser: function() {
    let postData = {
      email: this.$email.val(),
      mtCaptchaToken: this.mtCaptchaToken,
      reCaptchaToken: this.token
    };

    return $.ajax({
      type: 'POST',
      url: '/api/registerinit/registerinituser',
      data: postData,
      contentType: 'application/x-www-form-urlencoded'
    })
  },

  handleFailedRegistration: function(response) {
    if (!response.data.success) {
      this.token = '';
      if (this.isApacRegion === 'false') {
        if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
          grecaptcha.reset();
        }
      }
      this.$continueButton.removeClass(config.classes.isWhite).removeClass(config.classes.loadingClass);
      if (response.data.errorCode === config.events.forgotPassword.userAlreadyCreated) {
        this.$userAlreadyExists.addClass('error-message-icon');
        this.$userAlreadyExists.addClass(config.classes.isActive);
      } else {
        this.$somethingWentWrong.addClass(config.classes.isActive);
      }
    }
  },

  removeEmailErrorMessages: function removeEmailErrorMessages() {
    if (this.$userAlreadyExists.hasClass(config.classes.isActive) && this.$userAlreadyExists.hasClass('error-message-icon')) {
      this.$userAlreadyExists.removeClass('error-message-icon');
      this.$userAlreadyExists.removeClass(config.classes.isActive);
    }
    if (this.$continueButton.hasClass(config.classes.isWhite)) {
      this.$continueButton.removeClass(config.classes.isWhite).removeClass(config.classes.loadingClass);
    }
    if (this.$somethingWentWrong.hasClass(config.classes.isActive)) {
      this.$somethingWentWrong.removeClass(config.classes.isActive);
    }
  }
},
{
  create: function($parent) {
    $parent.find('.GetStarted').each(function(n, el) {
      new GetStartedView({
        el: el
      });
    });
  }
});
module.exports = GetStartedView;



// WEBPACK FOOTER //
// ./assets/components/Registration/GetStarted.js